import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { siteConfig } from '../../config/site';

const Wrap = styled.section`
  background: linear-gradient(135deg, var(--background-dark) 0%, var(--background-light) 100%);
  padding: 6rem 1rem 4rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 20% 30%, rgba(0, 153, 0, 0.12) 0%, transparent 55%),
                radial-gradient(circle at 80% 70%, rgba(0, 153, 0, 0.10) 0%, transparent 55%);
  }
`;

const Inner = styled.div`
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  text-align: center;
`;

const Eyebrow = styled.div`
  display: inline-block;
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(0, 153, 0, 0.08);
  color: var(--primary-color);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: clamp(2.25rem, 5vw, 3.75rem);
  line-height: 1.1;
  margin: 0 0 1.25rem;
  color: var(--text-color);

  span {
    color: var(--primary-color);
  }
`;

const Lede = styled.p`
  font-size: 1.15rem;
  line-height: 1.7;
  color: var(--text-secondary);
  max-width: 700px;
  margin: 0 auto 2.25rem;
`;

const Actions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const PrimaryLink = styled(Link)`
  background: var(--primary-color);
  color: var(--text-color);
  padding: 0.9rem 1.75rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.2s ease;
  &:hover { transform: translateY(-2px); background: var(--primary-dark, var(--primary-color)); }
`;

const GhostLink = styled(Link)`
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  padding: 0.9rem 1.75rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease;
  &:hover { background: rgba(0, 153, 0, 0.1); }
`;

const BlogHero: React.FC = () => (
  <Wrap>
    <Inner>
      <Eyebrow>The {siteConfig.brand.name} Blog</Eyebrow>
      <Title>
        Insights on <span>USDT flashing</span>, stablecoins, and blockchain.
      </Title>
      <Lede>
        Guides, tutorials, and analysis for cryptocurrency users, developers, and
        traders exploring flash USDT technology, TRC-20/ERC-20 networks, and the
        wider stablecoin ecosystem.
      </Lede>
      <Actions>
        <PrimaryLink to="/blog">Read the latest posts</PrimaryLink>
        <GhostLink to="/about">About this blog</GhostLink>
      </Actions>
    </Inner>
  </Wrap>
);

export default BlogHero;
